import { FC, useEffect, useState } from 'react';
import { WistiaS } from '../../Service/WistiaS';
import { WistiaMedia } from '../../Types/WistiaT';
import { ThemeText, ThemeTitle } from '../../Atoms/ThemeText';
import WistiaVideoPlayer from './WistiaVideoPlayer';

const WistiaVideoWrapper: FC<{ mediaId: string; hideLabel?: boolean }> = ({ mediaId, hideLabel = false }) => {
  const [video, setVideo] = useState<WistiaMedia | null>(null);

  useEffect(() => {
    WistiaS.fetchMediaDetails(mediaId).then(setVideo);
  }, [mediaId]);

  if (!video) return null;

  const { name, description } = video;

  return (
    <>
      {!hideLabel && (
        <ThemeTitle mb="sm" order={3}>
          {name}
        </ThemeTitle>
      )}
      <WistiaVideoPlayer mediaId={mediaId} />
      {description && description.trim() !== '' && (
        <>
          <ThemeTitle order={5} mt="xs">
            Videobeschreibung
          </ThemeTitle>
          <ThemeText mt="sm" className="space-preserve" dangerouslySetInnerHTML={{ __html: description }} />
        </>
      )}
    </>
  );
};

export default WistiaVideoWrapper;
